import { actions as formActions } from 'react-redux-form'

import * as h2Api from '../../h2Api'
import { COMPANY_LOAD } from '../localopportunities/localopportunities'

export const PROFILE_LIST_LOAD = 'ADMIN_PROFILE_LIST_LOAD'
export const PROFILE_CHANGE_FIELD = 'ADMIN_PROFILE_CHANGE_FIELD'
export const PROFILE_CREATE = 'ADMIN_PROFILE_CREATE'
export const PROFILE_DELETE = 'ADMIN_PROFILE_DELETE'
export const PROFILE_TOGGLE_ACTIVE = 'ADMIN_PROFILE_TOGGLE_ACTIVE'
export const SEARCH_TERM_UPDATE = 'ADMIN_PROFILE_SEARCH_TERM_UPDATE'
export const TOGGLE_ADD_MODAL = 'ADMIN_PROFILE_TOGGLE_ADD_MODAL'
export const PROFILE_CHANGE_CREATION_FIELD = 'ADMIN_PROFILE_CHANGE_CREATION_FIELD'
export const PROFILE_NOTES_LOADED = 'ADMIN_PROFILE_NOTES_LOADED'
export const ADMIN_PROFILE_NOTES_SAVED = 'ADMIN_PROFILE_NOTES_SAVED'
export const PROFILE_NOTES_ADDED = 'PROFILE_NOTES_ADDED'
export const ADMIN_PROFILE_INTAKE_FORMS = 'ADMIN_PROFILE_INTAKE_FORMS'
export const ADMIN_FILTER_OPTIONS_LOADED = 'ADMIN_FILTER_OPTIONS_LOADED'

export const ADMIN_PROFILE_REPORT_LOADED = 'ADMIN_PROFILE_REPORT_LOADED'
export const ADMIN_PROFILE_REPORT_CLEAR = 'ADMIN_PROFILE_REPORT_CLEAR'

export const PROFILE_CONTACTS_LOADED = 'ADMIN_PROFILE_CONTACTS_LOADED'
export const PROFILE_CONTACT_ADDED = 'ADMIN_PROFILE_CONTACT_ADDED'
export const PROFILE_CONTACT_UPDATED = 'ADMIN_PROFILE_CONTACT_UPDATED'
export const ADMIN_PROFILE_CONTACT_SAVED = 'ADMIN_PROFILE_CONTACT_SAVED'
export const ALL_CONTACTS_LOADED = 'ADMIN_ALL_CONTACTS_LOADED'
export const CONTACT_DETAIL_LOADED = 'CONTACT_DETAIL_LOADED'
export const ADMIN_QUEUE_EDIT_SUBMISSION = 'ADMIN_QUEUE_EDIT_SUBMISSION'
export const WBL_FILTER_OPTIONS_LOADED = 'WBL_FILTER_OPTIONS_LOADED'

export const CONTACT_SUBMISSION_LOAD = 'CONTACT_SUBMISSION_LOAD'
export const CONTACT_SUBMISSION_SAVE = 'CONTACT_SUBMISSION_SAVE'

export const CONTACT_APPLICATION_QUEUE = 'CONTACT_APPLICATION_QUEUE'
export const COMPANY_SUGGESTIONS_RECEIVED = 'COMPANY_SUGGESTIONS_RECEIVED'
export const CONTACT_DELETED = 'CONTACT_DELETED'

export const LOCAL_OPPS_TASK_QUEUE = 'LOCAL_OPPS_TASK_QUEUE'
export const LOCAL_OPPS_TASK_DETAIL = 'LOCAL_OPPS_TASK_DETAIL'
export const LOCAL_OPPS_TASK_PLACE = 'LOCAL_OPPS_TASK_PLACE'
export const LOCAL_OPPS_UPDATE_TASK = 'LOCAL_OPPS_UPDATE_TASK'
export const LOCAL_OPPS_DASHBOARD = 'LOCAL_OPPS_DASHBOARD'
export const ADMIN_PROFILE_CONTACT_TYPES_SAVED = 'ADMIN_PROFILE_CONTACT_TYPES_SAVED'
export const ADMIN_PROFILE_CONTACT_INVITE = 'ADMIN_PROFILE_CONTACT_INVITE'
export const GENERATE_TASKLIST_XLS = 'GENERATE_TASKLIST_XLS'

export const PROFILE_ADD_DOMAIN_ASSOCIATION = 'PROFILE_ADD_DOMAIN_ASSOCIATION'
export const PROFILE_DELETE_DOMAIN_ASSOCIATION = 'PROFILE_DELETE_DOMAIN_ASSOCIATION'
export const ADMIN_PLACEMENT_NOTES_SAVED = 'ADMIN_PLACEMENT_NOTES_SAVED'

export const WBL_TYPE_LOAD = 'WBL_TYPE_LOAD'

export const loadWblTypeDetail = profileId => {
  return h2Api.get(`/profiles/admin/wbltype/${profileId}`)({ type: WBL_TYPE_LOAD })
}

export const toggleWblTypeActive = profileId => {
  return h2Api.post(`/profiles/admin/wbltype/${profileId}/toggleactive`)({
    type: WBL_TYPE_LOAD
  })
}

export const saveWblType = (id, data) => {
  return h2Api.put(`/profiles/admin/wbltype/${id}`, data)({ type: WBL_TYPE_LOAD })
}

export const deleteWblType = (id, data) => {
  return h2Api.doDelete(`/profiles/admin/wbltype/${id}`)({ type: WBL_TYPE_LOAD })
}

export const updatePage = page => (dispatch, getState) => {
  const searchTerm = getState().admin.localOpportunities.other.searchTerm
  const toPost = searchTerm ? { term: searchTerm, page } : { page }

  return dispatch(h2Api.post('/profiles/admin/list', toPost)({ type: PROFILE_LIST_LOAD }))
}

export const loadSubmissionForReview = id => {
  return h2Api.get(`/profiles/contacts/submissions/${id}`)({
    type: CONTACT_SUBMISSION_LOAD
  })
}

export const searchExistingCompanies = term => {
  console.log(term)

  return h2Api.get(`/search/suggest/company/${term}`)({
    type: COMPANY_SUGGESTIONS_RECEIVED
  })
}

export const updateSubmission = (submissionId, formData) => {
  return h2Api.put(
    `/profiles/contacts/submissions/${submissionId}`,
    formData
  )({ type: CONTACT_SUBMISSION_SAVE })
}

export const updateSearch = (field, term) => dispatch => {
  return dispatch({ type: SEARCH_TERM_UPDATE, field, searchTerm: term })
}

export const changeFormField = (fieldValueMap, fieldName, value) => dispatch => {
  return dispatch({
    type: PROFILE_CHANGE_FIELD,
    fieldValueMap,
    fieldName,
    fieldValue: value
  })
}

export const changeCreationFormField = (fieldValueMap, fieldName, value) => dispatch => {
  return dispatch({
    type: PROFILE_CHANGE_CREATION_FIELD,
    fieldValueMap,
    fieldName,
    fieldValue: value
  })
}

export const addDomain = (profileId, domain) => dispatch => {
  return dispatch(
    h2Api.post(`/profiles/admin/company/${profileId}/domain`, { domain })({
      type: PROFILE_ADD_DOMAIN_ASSOCIATION
    })
  )
}

export const removeDomain = (profileId, domainId) => dispatch => {
  return dispatch(
    h2Api.doDelete(`/profiles/admin/company/${profileId}/domain/${domainId}`)({
      type: PROFILE_DELETE_DOMAIN_ASSOCIATION
    })
  )
}

export const loadNotes = profileId => dispatch => {
  return dispatch(
    h2Api.get(`/profiles/${profileId}/notes`)({ type: PROFILE_NOTES_LOADED })
  )
}

export const loadContacts = profileId => dispatch => {
  return dispatch(
    h2Api.get(`/profiles/${profileId}/contacts`)({ type: PROFILE_CONTACTS_LOADED })
  )
}

export const loadAllContacts = () => dispatch => {
  return dispatch(h2Api.get(`/profiles/contacts`)({ type: ALL_CONTACTS_LOADED }))
}

export const searchContacts = form => dispatch => {
  console.log(form)
  const { clusters, wblTypes, ...rest } = form

  if (clusters) {
    rest.clusters = [clusters]
  }

  if (wblTypes) {
    rest.wblTypes = [wblTypes]
  }

  return dispatch(h2Api.post(`/profiles/contacts`, rest)({ type: ALL_CONTACTS_LOADED }))
}

export const loadContactFilterOptions = () => {
  return h2Api.get(`/profiles/contacts/filters`)({ type: WBL_FILTER_OPTIONS_LOADED })
}

export const loadContact = contactId => {
  return h2Api.get(`/profiles/contacts/${contactId}`)({ type: CONTACT_DETAIL_LOADED })
}

export const deleteContact = contactId => {
  return h2Api.doDelete(`/profiles/contacts/${contactId}`)({ type: CONTACT_DELETED })
}

export const createContact = (profileId, form) => dispatch => {
  return dispatch(
    h2Api.post(
      `/profiles/${profileId}/contact`,
      form
    )({ type: ADMIN_PROFILE_CONTACT_SAVED })
  )
}

export const updateContact = (profileId, contactId, form) => dispatch => {
  return dispatch(
    h2Api.put(
      `/profiles/${profileId}/contact/${contactId}`,
      form
    )({ type: ADMIN_PROFILE_CONTACT_SAVED })
  )
}

export const addOptionsToContact = (contactId, typeId, values) => {
  return h2Api.post(
    `/profiles/contacts/${contactId}/${typeId}`,
    values
  )({ type: ADMIN_PROFILE_CONTACT_TYPES_SAVED })
}

export const inviteContact = (companyId, email, message) => {
  return h2Api.post(`/profiles/contacts/requestforcompany/${companyId}`, {
    email,
    message
  })({ type: ADMIN_PROFILE_CONTACT_INVITE })
}

export const initialLocalOpportunityContactModel = {
  firstName: '',
  lastName: '',
  position: '',
  email: '',
  officePhone: '',
  mobilePhone: '',
  address: '',
  city: '',
  state: '',
  zip: ''
}

export const selectContactForEdit = (contact, formKey) => dispatch => {
  return dispatch(formActions.change(formKey, contact))
}

export const createNoteForUser = (profileId, contactId, body) => dispatch => {
  const formData = new FormData()
  const { file, ...other } = body

  Array.from(file).forEach(f => formData.append('file', f))
  formData.append('json', JSON.stringify({ ...other, contactId }))

  return dispatch(
    h2Api.postFile(
      `/profiles/${profileId}/notes`,
      formData
    )({ type: ADMIN_PROFILE_NOTES_SAVED })
  )
}

export const createPlacementNote = (applicationId, body) => dispatch => {
  const formData = new FormData()
  const { file, ...other } = body

  Array.from(file).forEach(f => formData.append('file', f))
  formData.append('json', JSON.stringify({ ...other }))

  return dispatch(
    h2Api.postFile(
      `/profiles/admin/application/${applicationId}/notes`,
      formData
    )({ type: ADMIN_PLACEMENT_NOTES_SAVED })
  )
}

export const createNote = (profileId, body) => dispatch => {
  const formData = new FormData()
  const { file, ...other } = body

  Array.from(file).forEach(f => formData.append('file', f))
  formData.append('json', JSON.stringify(other))

  return dispatch(
    h2Api.postFile(
      `/profiles/${profileId}/notes`,
      formData
    )({ type: ADMIN_PROFILE_NOTES_SAVED })
  )
}

export const loadProfileIntakeForms = () => dispatch => {
  return dispatch(
    h2Api.get('/profiles/admin/intakeforms')({ type: ADMIN_PROFILE_INTAKE_FORMS })
  )
}

export const toggleProfileModal = s => dispatch => {
  return dispatch({ type: TOGGLE_ADD_MODAL, state: s })
}

export const loadFilterOptions = () => dispatch => {
  return dispatch(
    h2Api.get('/profiles/admin/filteroptions')({ type: ADMIN_FILTER_OPTIONS_LOADED })
  )
}

export const generateFilterParams = () => (dispatch, getState) => {
  const f = getState().admin.localOpportunities.other

  console.log(f)
  const {
    searchTerm,
    includeUnpublished,
    includeUnapproved,
    includeProfileType,
    clusterType,
    ...filterOptions
  } = f.filter
  const includeProfileTypes = includeProfileType.length > 0 ? includeProfileType : null
  const toPost = {}

  if (searchTerm) {
    toPost.term = searchTerm
  }

  if (['true', 'false'].includes(includeUnpublished)) {
    toPost.published = includeUnpublished == 'true'
  }

  if (['true', 'false'].includes(includeUnapproved)) {
    toPost.approved = includeUnapproved == 'true'
  }

  if (includeProfileType) {
    toPost.profileType = includeProfileTypes
  }

  const filterOptionsArray = Object.keys(filterOptions).map(k => ({
    key: k,
    value: filterOptions[k]
  }))

  return {
    ...toPost,
    clusterType,
    tags: filterOptionsArray
  }
}

export const loadProfileList = () => (dispatch, getState) => {
  const toPost = dispatch(generateFilterParams())

  return dispatch(h2Api.post('/profiles/admin/list', toPost)({ type: PROFILE_LIST_LOAD }))
}

export const loadProfileListWithFilter = filter => (dispatch, getState) => {
  return dispatch(h2Api.post('/profiles/admin/list', filter)({ type: PROFILE_LIST_LOAD }))
}

export const loadProfileReport = reportId => (dispatch, getState) => {
  const toPost = dispatch(generateFilterParams())

  return dispatch(
    h2Api.post(
      `/profiles/admin/report/${reportId}`,
      toPost
    )({ type: ADMIN_PROFILE_REPORT_LOADED, selectedReportId: reportId })
  )
}

export const clearReport = () => dispatch => {
  return dispatch({ type: ADMIN_PROFILE_REPORT_CLEAR })
}

export const createProfile = () => (dispatch, getState) => {
  const v = getState().admin.localOpportunities.other.companyProfileFieldValues
  //console.log(`/profiles/admin/${v.profileType}`)
  const js = { name: v.companyName }

  if (v.numColumns !== '-1') {
    js.numColumns = v.numColumns
  }

  return dispatch(
    h2Api.post(`/profiles/admin/${v.profileType}`, js)({ type: PROFILE_CREATE })
  ).then(created => {
    /*
     * commented out because I need to update the body class for the CSS to apply, reloading fixxes
     * browserHistory.push(`/profiles/${v.profileType}/${created.id}`)
     */
    window.location.href = `/profiles/${v.profileType}/${created.id}`
  })
}

export const deleteProfile = (profile, page) => dispatch => {
  return dispatch(markProfileDeleted(profile.id)).then(() => {
    return dispatch(updatePage(page))
  })
}

export const markProfileDeleted = profileId => {
  return h2Api.doDelete(
    `/profiles/admin/${profileId}`,
    {}
  )({ type: PROFILE_DELETE, profileId })
}

export const loadApplications = () => {
  return h2Api.get(`/profiles/admin/applications/list`)({
    type: CONTACT_APPLICATION_QUEUE
  })
}

export const toggleActive = (profile, page) => dispatch => {
  return dispatch(
    h2Api.put(`/profiles/${profile.type}/${profile.id}/activeToggle`)({
      type: PROFILE_TOGGLE_ACTIVE,
      profileId: profile.id
    })
  ).then(() => {
    return dispatch(updatePage(page))
  })
}

export const loadTasks = filters => {
  const filter = {}

  if (filters?.term) {
    filter.term = filters.term
  }

  if (filters?.type) {
    filter.types = [filters.type]
  }

  if (filters?.status) {
    filter.statuses = [filters.status]
  }

  if (filters?.onlyAssigned) {
    filter.onlyAssigned = filters.onlyAssigned
  }

  return h2Api.post(
    `/profiles/admin/applications/list`,
    filter
  )({ type: LOCAL_OPPS_TASK_QUEUE })
}

/** should be load Application, eventually should be refactored*/
export const loadTask = taskId => {
  return h2Api.get(`/profiles/admin/application/${taskId}`)({
    type: LOCAL_OPPS_TASK_DETAIL
  })
}

export const deleteApplication = applicationId => {
  return h2Api.doDelete(`/profiles/admin/application/${applicationId}`)({
    type: LOCAL_OPPS_TASK_DETAIL
  })
}

export const placeUser = (taskId, contact, form) => {
  console.log(contact, form)

  return h2Api.post(`/profiles/admin/application/${taskId}/place`, {
    ...form,
    companyProfileId: contact.companyId,
    companyContactId: contact.id
  })({ type: LOCAL_OPPS_UPDATE_TASK })
}

export const placeUserExternally = (taskId, form) => {
  console.log(form)

  return h2Api.post(`/profiles/admin/application/${taskId}/externalplacement`, {
    ...form
  })({ type: LOCAL_OPPS_UPDATE_TASK })
}

export const acceptTask = (taskId, assignToObj) => {
  const assignTo = !isNaN(assignToObj.id) ? parseInt(assignToObj.id) : assignToObj

  return h2Api.post(`/profiles/admin/application/${taskId}/accept`, {
    assignTo
  })({ type: LOCAL_OPPS_UPDATE_TASK })
}

export const rejectTask = (taskId, comment) => {
  return h2Api.post(`/profiles/admin/application/${taskId}/reject`, {
    comment
  })({ type: LOCAL_OPPS_UPDATE_TASK })
}

export const changeStatusForTask = (taskId, statusId) => {
  return h2Api.post(`/profiles/admin/application/${taskId}/status`, {
    statusId
  })({ type: LOCAL_OPPS_UPDATE_TASK })
}

export const changeStatusForTasks = (taskIds, statusId) => {
  return h2Api.post(`/profiles/admin/application/status`, {
    taskIds,
    statusId
  })({ type: LOCAL_OPPS_UPDATE_TASK })
}

export const assignTask = (taskId, assignToObj) => {
  const assignTo = !isNaN(assignToObj.id) ? parseInt(assignToObj.id) : assignToObj

  return h2Api.post(`/profiles/admin/application/${taskId}/assignTo`, {
    assignTo
  })({ type: LOCAL_OPPS_UPDATE_TASK })
}

export const completeTask = taskId => {
  return h2Api.post(
    `/profiles/admin/application/${taskId}/complete`,
    {}
  )({ type: LOCAL_OPPS_UPDATE_TASK })
}

export const loadDashboard = () => {
  return h2Api.get(`/profiles/admin/dashboard`)({ type: LOCAL_OPPS_DASHBOARD })
}

export const generateExcelTasklist = sIds => {
  const json = {}

  if (sIds != '') {
    json.statusIds = [parseInt(sIds)]
  }

  return h2Api.post(`/profiles/admin/tasklist/xls`, { json })({
    type: GENERATE_TASKLIST_XLS
  })
}
